module.exports = __webpack_public_path__ + "img/packshots-hd_old.31b05b9a.png";